import { Logger } from '@frontend/logger';

import { AndroidWebViewApp } from '../android-webview/android-webview-app';

/** Must stay below the native 180s heartbeat timeout. */
export const KEEP_ALIVE_INTERVAL_MS = 120_000;

const androidWebView = AndroidWebViewApp.getInstance();

let intervalId: ReturnType<typeof setInterval> | null = null;
let activeDeviceId: string | null = null;

function ping(deviceId: string): void {
    if (androidWebView.keepAlive(deviceId)) {
        Logger.log('[keep-alive] ping', deviceId);
    }
}

export function startKeepAlive(deviceId: string): void {
    if (activeDeviceId === deviceId && intervalId !== null) {
        return;
    }

    stopKeepAlive();
    activeDeviceId = deviceId;

    androidWebView.reportMissingBridgeMethods();
    ping(deviceId);
    intervalId = setInterval(() => ping(deviceId), KEEP_ALIVE_INTERVAL_MS);

    Logger.log('[keep-alive] started', { deviceId, intervalMs: KEEP_ALIVE_INTERVAL_MS });
}

export function stopKeepAlive(): void {
    if (intervalId !== null) {
        clearInterval(intervalId);
        intervalId = null;
    }

    if (activeDeviceId !== null) {
        Logger.log('[keep-alive] stopped', activeDeviceId);
        activeDeviceId = null;
    }
}
